import type { JsonFilter } from '@/hooks/use-table-filter/types';
import type { Invoice } from '@pigello/pigello-matrix';

export const getFailedAutogiroTransactionAttemptsFilters =
  (): JsonFilter<Invoice> => ({
    autogiro_enabled: { noop: true },
    has_failed_autogiro_payment: { noop: true },
    has_successful_autogiro_payment: { noop: false },
    closed_time: { __isnull: true },
  });
